import { render } from "./BrandIcon.vue?vue&type=template&id=390cc9c4&lang=pug"
import script from "./BrandIcon.vue?vue&type=script&lang=js"
export * from "./BrandIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__